import { render } from "./PublicationsSearch.vue?vue&type=template&id=632250e8&scoped=true"
import script from "./PublicationsSearch.vue?vue&type=script&lang=js"
export * from "./PublicationsSearch.vue?vue&type=script&lang=js"

import "./PublicationsSearch.vue?vue&type=style&index=0&id=632250e8&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632250e8"]])

export default __exports__